import {
    getBaseCurrencySymbol,
    withBaseCurrency,
} from 'utils/helpers/currency/currencyHelpers';

export const formatPrice = (price) => {
    return (price || 0).toLocaleString('en-US', {
            minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export const format$Price = (price, showPlus = false) =>{ 
    const symbol = getBaseCurrencySymbol();
    return price>=0
        ? `${showPlus?'+':''}${symbol} ${formatPrice(price)}`
        : withBaseCurrency(formatPrice(-price), true)
}
